import { View } from './view'

export const ProductAdvantage = View
